import { localStorageInstance } from "./localStorage";

export function isAdmin() {
  const userData =
    sessionStorage.getItem("role") || localStorageInstance.getItem("role");
  return userData == "Super Admin";
}

export function currentUserId() {
  const userData =
    sessionStorage.getItem("userId") || localStorageInstance.getItem("userId");
  return userData;
}
export function currentUserToken() {
  const token =
    sessionStorage.getItem("authToken") ||
    localStorageInstance.getItem("token");
  return token;
}

export function currentUserPlannerToken() {
  const token = localStorageInstance.getItem("planner_access_token");
  return token;
}

export const getAPIBaseUrl = () => {
  const url = `${window.location.protocol}//${window.location.hostname}/api`;

  return window.location.hostname === "localhost"
    ? "https://sofmen.taskboard.sofmen.com/api"
    : url;
};

export const getAPIBaseUrlVersion1 = () => {
  const url = `${window.location.protocol}//${window.location.hostname}/api/v1`;

  return window.location.hostname === "localhost"
    ? "https://sofmen.taskboard.sofmen.com/api/v1"
    : url;
};
